import {onMounted, ref} from 'vue'
import {useToast} from 'primevue/usetoast'
import {toTypedSchema} from '@vee-validate/zod'
import {useForm} from 'vee-validate'
import {useRouter} from 'vue-router'
import {rollSchema} from '@/schemas/rollSchema'
import {getRollById} from "@/api/rolls"
import {getBatchById} from "@/api/batches"
import type { Batch } from '@/types/batch-types'

export const useRollForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(rollSchema)
  })
  const toast = useToast()
  const loading = ref(false)
  const router = useRouter()

  const batch = ref<Batch>()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  onMounted(async () => {
    if (formType !== 'add') {
      const rollId = router.currentRoute.value.params.id as string
      const roll = await getRollById(rollId)
      if (roll) {
        resetForm({
          values: {
            ...roll,
            returnedRollId: roll.returnedRollId || '00000000-0000-0000-0000-000000000000',
            rollState: roll.rollState ?? 0,
            dateKnitted: roll.dateKnitted || new Date().toISOString(),
            isActive: roll.isActive ?? true
          }
        });
        if (roll.batchId) {
          batch.value = await getBatchById(roll.batchId)
        }
      }
    }
  })

  return {
    values,
    batch,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    loading,
    showToast,
    formType
  }
}
